import * as Yup from "yup";
import { hasEveryRequiredResource } from "../../helpers/resourceAllocations";

export const hasUnavailableAdditionalServiceResources = (values = {}) =>
  [values.addonservices, values.addanotherservices].some((lines) =>
    Array.isArray(lines) && lines.some((line) => line.resource_unavailable === true));

export const additionalServiceResourceUnavailableMessage = (t) => t(
  "No resource is available for this additional service at the selected time. Choose another time or service.",
);

export const appointmentAdditionalServicesSchema = (t) => Yup.array().of(
  Yup.object().shape({
    service_id: Yup.mixed().required(t("Service is required")),
    staff_id: Yup.mixed().required(t("Staff is required")),
    cost: Yup.mixed().required(t("Cost is required")),
    resource_required: Yup.boolean().default(false),
    resource_unavailable: Yup.boolean().default(false),
    resource_allocations: Yup.array().test(
      "all-required-resources",
      t("Resource is required for this additional service"),
      function allRequiredResources(value) {
        const requirements = this.parent.resource_requirements;
        return !Array.isArray(requirements) || !requirements.length
          || hasEveryRequiredResource({ resource_requirements: requirements }, value);
      },
    ),
    resource_item_id: Yup.string()
      .nullable()
      .when(["resource_required", "resource_requirements"], {
        is: (required, requirements) => required && (!Array.isArray(requirements) || !requirements.length),
        then: () => Yup.string()
          .test(
            "resource-available",
            additionalServiceResourceUnavailableMessage(t),
            function resourceAvailable() {
              return this.parent.resource_unavailable !== true;
            },
          )
          .required(t("Resource is required for this additional service")),
      }),
  }),
);
